export default __webpack_public_path__ + "static/media/Maven.5b848dce.png";